import { createMutation } from "@/api/utils";

export const generateFinanceLabMetrics = createMutation<any>(
    ({ api, payload }) => {
        return api.post(
            `/hum-finance-lab/v1/companies/${payload.companyId}/metrics/generate`,
        );
    },
);
